<mat-card class="cardPanel mat-elevation-z5">
    <mat-card-header class="loginHeading">
        <mat-card-title>Sign In</mat-card-title>
      </mat-card-header>
    <section class="loginInfo">
        <h2>Welcome back</h2>
        <h4>Sign in with your credentials below.</h4>

    <form class="formFields" fxLayout="column" [formGroup]="loginForm">
        <mat-form-field appearance="fill">
            <mat-label>Username</mat-label>
            <input matInput type="text" formControlName="username" required />
            <mat-error *ngIf="usernameControl.invalid && usernameControl.hasError('required')">Missing username </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Password</mat-label>
            <input matInput [type]="hidePassword ? 'password' : 'text'" (keyup.enter)="login()" formControlName="password" required />
            <!-- <button
                mat-icon-button
                matSuffix
                (click)="hidePassword = !hidePassword"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hidePassword"
            >
                <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button> -->
            <mat-error *ngIf="passwordControl.invalid && passwordControl.hasError('required')">Missing password </mat-error>
        </mat-form-field>
    </form>

    <div class="invalidLogin">
        <mat-error *ngIf="error">{{ errorText }}</mat-error>
    </div>

</section>
    <mat-card-actions class="loginButton">
        <button mat-raised-button color="primary" type="submit" (click)="login()" [disabled]="loggingIn">
            <ng-container *ngIf="!loggingIn">SIGN IN</ng-container>
            <ng-container *ngIf="loggingIn">
                <div style="display: flex; justify-content: center; align-items: center">
                    <mat-progress-spinner
                        color="primary"
                        mode="indeterminate"
                        diameter="20"
                        style="margin-right: 10px"
                    ></mat-progress-spinner>
                    <span>LOGGING IN...</span>
                </div>
            </ng-container>
        </button>
    </mat-card-actions>
</mat-card>
